import type { ContributionPurposeCode } from "./types";

const accountPurposeMap: Record<string, ContributionPurposeCode> = {
  TITHE: "tithe",
  TITHES: "tithe",
  OFFERING: "offering",
  OFF: "offering",
  BUILD: "building",
  BUILDING: "building",
  MISSIONS: "missions",
  MISSION: "missions",
  WELFARE: "welfare",
  GENERAL: "general"
};

export function purposeFromAccountNumber(account: string | null | undefined): ContributionPurposeCode {
  if (!account) return "unclassified";
  const token = account.trim().split(/[-_\s/]+/)[0]?.toUpperCase() ?? "";
  return accountPurposeMap[token] ?? "unclassified";
}

export function memberCodeFromAccountNumber(account: string | null | undefined): string | null {
  if (!account) return null;
  const tokens = account.trim().split(/[-_\s/]+/).filter(Boolean);
  const memberToken = tokens.find((token) => /^[A-Z]?\d{3,}$/i.test(token));
  return memberToken ? memberToken.toUpperCase() : null;
}

export function purposeLabel(code: ContributionPurposeCode): string {
  return {
    tithe: "Tithe",
    offering: "Offering",
    building: "Building Fund",
    missions: "Missions",
    welfare: "Welfare",
    general: "General",
    unclassified: "Unclassified"
  }[code];
}
